<template>
    <div class="text-red text-sm p-2" v-if="errorMessage != null">
        {{ errorMessage }}
    </div>
</template>

<script>
import { computed } from "@vue/runtime-core";
import { useStore } from "vuex";
import { HELPER_TYPES, STORE_TYPES } from "../../store/types";
import { getData } from "../../common/dataHelper";
export default {
    props: {
        name: {
            type: String,
            default: null,
        },
    },
    setup(props) {
        const store = useStore();

        const errorss = computed(() => {
            return store.getters[
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.GET_ERROR_IDS}`
            ];
        });

        /**
         * Error Message corresponding to props.name
         */
        const errorMessage = computed(() => {
            if (props.name == null) return null;
            const errors =
                store.getters[
                    `${STORE_TYPES.HELPERS}/${HELPER_TYPES.GET_ERROR_IDS}`
                ];
            if (errors == null || errors.length == 0) return null;
            return getData(errors, `${props.name}.0`);
        });

        return {
            errorMessage,
            errorss,
        };
    },
};
</script>

<style></style>
